'use memo'

import type { ComponentType } from 'react'
import {
  CustomizationIcon,
  EmailCustomizationIcon,
  GeneralSettingsIcon,
  PaymentsIcon,
  PlayerCustomFormIcon,
  TeamCustomFormIcon,
  WaiverIcon,
} from '../components/SidebarIcons'
import type { SidebarIconProps } from '../components/SidebarIcons'
import { useRegistrationSetupContext } from '../context'

type SidebarIconComponent = ComponentType<SidebarIconProps>

export type TabItem = {
  key: string
  label: string
  icon: SidebarIconComponent
  disabled: boolean
  disabledTooltip?: string
}

const labelById: Record<number, string> = {
  0: 'General Settings',
  1: 'Payments',
  2: 'Player Waivers',
  3: 'Team Custom Form',
  4: 'Player Custom Form',
  5: 'Header Customization',
  6: 'Email Customization',
}

const iconById: Record<number, SidebarIconComponent> = {
  0: GeneralSettingsIcon,
  1: PaymentsIcon,
  2: WaiverIcon,
  3: TeamCustomFormIcon,
  4: PlayerCustomFormIcon,
  5: CustomizationIcon,
  6: EmailCustomizationIcon,
}

export function useRegistrationSetupTabs(
  isLegacyRegistration: boolean
): TabItem[] {
  const { state, apiWaivers } = useRegistrationSetupContext()

  const waiverDisabled = !apiWaivers || apiWaivers.length === 0
  const emailDisabled =
    !state.enableTeamRegistration && !state.enablePlayerRegistration

  const items: TabItem[] = [
    {
      key: '0',
      label: labelById[0],
      icon: iconById[0],
      disabled: false,
    },
    {
      key: '1',
      label: labelById[1],
      icon: iconById[1],
      disabled: false,
    },
    {
      key: '2',
      label: labelById[2],
      icon: iconById[2],
      disabled: waiverDisabled,
      disabledTooltip: waiverDisabled
        ? 'Waiver(s) are required for signature during registration. New waivers can be added via Account Settings.'
        : undefined,
    },
  ]

  if (!isLegacyRegistration && state.enableTeamRegistration) {
    items.push({
      key: '3',
      label: labelById[3],
      icon: iconById[3],
      disabled: false,
    })
  }

  if (!isLegacyRegistration && state.enablePlayerRegistration) {
    items.push({
      key: '4',
      label: labelById[4],
      icon: iconById[4],
      disabled: false,
    })
  }

  items.push({
    key: '5',
    label: labelById[5],
    icon: iconById[5],
    disabled: false,
  })

  items.push({
    key: '6',
    label: labelById[6],
    icon: iconById[6],
    disabled: emailDisabled,
  })

  return items
}
